import { render } from "./HiddenSetingsOverlay.vue?vue&type=template&id=23fdee08"
import script from "./HiddenSetingsOverlay.vue?vue&type=script&lang=js"
export * from "./HiddenSetingsOverlay.vue?vue&type=script&lang=js"

import "./HiddenSetingsOverlay.vue?vue&type=style&index=0&id=23fdee08&lang=scss"
script.render = render

export default script